// comments: React + Formik + react-toastify
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Victor from "assets/VectorFooter.svg";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify"; // ✅ added
import "react-toastify/dist/ReactToastify.css"; // ✅ default styles
import contentApi from "../../../../api/contentApi"; // غيّر المسار حسب مشروعك

const ContactInformations = ({ homeData, SettingData }) => {
  const { i18n, t } = useTranslation("Footer");
  const currentLang = i18n.language === "ar" ? "hint_ar" : "hint_en";

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (homeData && SettingData) setIsLoading(false);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) =>
          entry.isIntersecting
            ? entry.target.classList.add("animate-visible")
            : entry.target.classList.remove("animate-visible")
        );
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll(".animate-section");
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [homeData, SettingData]);

  if (isLoading) return <div>Loading...</div>;

  const homeTitle = homeData;
  const companyInformation = SettingData;

  // handle submit newsletter
  const handleSubmit = async (values, { resetForm }) => {
    try {
      await contentApi.NewsLetterMessage(values); // { email }
      toast.success(t("Message sent successfully!"), { autoClose: 5000 });
      resetForm();
    } catch (error) {
      toast.error(
        t("An error occurred while sending. Please try again."),
        { autoClose: 5000 }
      );
      console.error(error);
    }
  };

  const Schema = Yup.object().shape({
    email: Yup.string()
      .email(t("Please enter a valid email"))
      .required(t("pleaseEnterEmail")),
  });

  return (
    <>
      <div id="contactus"></div>
      <div className="main-container scale-95 lg:w-[92%] relative mx-auto my-5 p-4 md:py-16 flex justify-center">
        <div className="w-full lg:w-[1200px] lg:h-[400px] bg-[#0d6b70] rounded-[32px] flex flex-col lg:flex-row justify-between items-center px-5 lg:py-20 max-sm:py-8 md:px-20 md:py-8">
          <div className="flex flex-col gap-5 text-start text-[#fff] lg:w-2/3 px-2">
            <h1 className="text-[24px] md:text-[34px] font-extrabold leading-snug md:tracking-wider animate-section transition-opacity duration-1000">
              {homeTitle?.data?.sections[4]?.title}
            </h1>
            <p className="text-[14px] text_small_Bukra md:text-[16px] mt-4 leading-relaxed animate-section transition-opacity duration-1000">
              {homeTitle?.data?.sections[4]?.Posts[0]?.description}
            </p>

            {/* ✅ Newsletter Form */}
            <Formik
              initialValues={{ email: "" }}
              validationSchema={Schema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form className="relative w-80 h-14 mt-10">
                  <div className="relative w-80 h-14">
                    <Field
                      as="input"
                      type="email"
                      name="email"
                      placeholder={t("email")}
                      className="custom-placeholder w-full h-full pl-14 pr-6 bg-[#f0f8ff] text-[#181818] text-sm font-medium rounded-[36px] focus:outline-none"
                    />

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-10 h-10 absolute rtl:left-2 ltr:right-2 top-2 rounded-full flex items-center justify-center bg-white disabled:opacity-60"
                    >
                      <img src="/icon/SendIcons.svg" alt="Send" />
                    </button>
                  </div>

                  {/* {errors.email && touched.email ? (
                    <span className="block mt-2 text-sm text-white">
                      {errors.email}
                    </span>
                  ) : null} */}
                </Form>
              )}
            </Formik>
          </div>

          <div
            className="lg:w-[603.516px] h-[100%] bg-contain bg-center bg-no-repeat rounded-[16px] mb-6 lg:mb-0 lg:ml-0 xl:end-[1rem] absolute animate-section transition-opacity duration-1000"
            style={{ backgroundImage: `url(${Victor})` }}
          />
        </div>
      </div>

      {/* ✅ Toast container */}
      <ToastContainer position="top-right" />
    </>
  );
};

export default ContactInformations;
